const bcLink = (title, url, last) =>
    `<a href="${url}.html" class="${
        last ? 'footer__bc--active ' : ''
    }footer__bc__crumb footer__bc__break">${title}</a>`;

function updateCrumbs() {
    const _links = document.getElementsByClassName('js--bc-links')[0];
    const pathNames = window.location.pathname.slice(1).split('/');
    const pathsLength = pathNames.length - 1;
    let url = '';

    _links.innerHTML = pathNames
        .map((k, i) => {
            const [pathName] = k.split('.');
            url += `/${pathName}`;

            return bcLink(pathName, url, i === pathsLength);
        })
        .join('');
}

function init() {
    updateCrumbs();
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/footer.js